import { createFileRoute } from '@tanstack/react-router';
import { DealPage } from '@/pages/DealPage';

export const Route = createFileRoute('/_authed/deals/$id')({
  component: DealPage,
});
